const MAX_FILE_SIZE = 4194304;
export const ADD_CANDIDATE_MAX_FILE_SIZE = 2097152;

const commonFormat = [
  'application/pdf',
  'text/plain',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/rtf',
  'text/html',
  'application/rtf',
];

export const ACCEPTED_FILE_FORMATS = [
  ...commonFormat,
  'image/jpeg',
  'image/bmp',
  'image/png',
  'image/gif',
  'application/vnd.ms-outlook',
  '.msg',
];

export const ACCEPTED_ADD_CANDIDATE_FILE_FORMAT = [
  ...commonFormat,
  '.pdf',
  '.txt',
  '.doc',
  '.docx',
  '.html',
  '.rtf',
];

export const validateFileFormat = (
  filename: string,
  fileType: string,
  acceptedFileFormats = ACCEPTED_FILE_FORMATS,
) => {
  const fileExtension = filename.substr(filename.lastIndexOf('.'));
  return acceptedFileFormats.some(
    (format) => fileType === format || fileExtension.toLowerCase() === format,
  );
};

export const validateFileSize = (
  fileSize: number,
  maxFileSize = MAX_FILE_SIZE,
) => fileSize < maxFileSize;

export const validateFileNameChars = (fileName: string) =>
  !fileName.match(/[<\>\*%&\:\\]/i);
